// Keep popup isolation out of the saved drawing and classification inputs.
export function isolatePopupEntities(manifest, popup) {
  if (!popup || !manifest) return manifest ?? []
  const handles = popup.isolatedHandles == null ? null : new Set(popup.isolatedHandles)
  return manifest.filter(e =>
    e.layer === popup.sublayer.qbiqClass &&
    (e.original_layer_name ?? e.layer) === popup.sublayer.name &&
    (!handles || handles.has(e.handle)))
}
